import { Link2, LogIn, RefreshCw, ShieldAlert } from 'lucide-react';
import type { User } from '../types';

export function AccessBanner({
  user,
  isStaff,
  onLogin,
  onGoProfile,
  onRefresh
}: {
  user: User | null;
  isStaff: boolean;
  onLogin: () => void;
  onGoProfile: () => void;
  onRefresh: () => Promise<void>;
}) {
  if (user?.boundToGame) return null;

  if (!user) {
    return (
      <div className="access-banner guest">
        <ShieldAlert size={17} />
        <span>当前为游客浏览。登录并绑定游戏角色后才能发布/承接委托、购买商品、参与拍卖或兑换。</span>
        <button type="button" onClick={onLogin}><LogIn size={14} />登录</button>
      </div>
    );
  }

  return (
    <div className="access-banner unbound">
      <Link2 size={17} />
      <span>
        {isStaff
          ? '当前管理员账号未绑定游戏角色。后台管理可用，但交易功能已锁定。'
          : '当前账号未绑定游戏角色，只能浏览。绑定后才能发布/承接委托、购买/上架商品、参与拍卖、兑换或转账。'}
      </span>
      <button type="button" onClick={onGoProfile}><Link2 size={14} />去绑定</button>
      <button type="button" className="ghost" onClick={() => void onRefresh()}><RefreshCw size={14} />刷新状态</button>
    </div>
  );
}
